export default {"src":"/_next/static/media/line-bg2.564dd305.svg","height":211,"width":437,"blurWidth":0,"blurHeight":0};